// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class RoutePlanRuleRecord extends VerofreshRecord {

}

const relations = {
  belongsTo: {
    Customer: {
      foreignKey: 'customer_id',
      localField: 'customer'
    }
  }
}

export default RoutePlanRuleRecord
